<div class="transferannounced">

    <div class="menu">
        <span class="menu-heading"> Conference Callers</span>
        <span class="close" (click)="closeTaskSelectionMenu()">X</span>
    </div>
    <div class="menu">
        <span class="menu-heading">{{callersUserCountText}}</span>
        <span class="menu-heading">{{callersInternalCountText}}</span>
        <span class="menu-heading">{{callersExternalCountText}}</span>
    </div>
    <div class="console">
        <div class="row" style="margin: 0.313rem">

            <table class="ptab-table table">
                <thead>
                    <tr>
                    </tr>
                </thead>
                <tbody style="border-top: 0.063rem solid #97999b">
                    <tr *ngFor="let caller of getCallersList()">

                        <td style="width:100%;">
                            <div style="width:100%; text-align:left"> {{((caller.UserType == 'ThirdParty') ? 'External' : caller.CallerName)}}</div>

                            <div style="width:100%; text-align:left"> {{formatPhoneNumber(caller.PhoneNumber,'')}}</div>
                        </td>

                        <td>

                            <button *ngIf="!caller.ishold"
                                    class="bi bi-pause"
                                    style="-webkit-text-stroke: 0.063rem;border: none; height: 25px; width: 30px;"
                                    (click)="HoldCall(caller)"></button>
                            <button *ngIf="caller.ishold" class="bi bi-play" style="border: none; height: 25px; width: 30px;" (click)="HoldCall(caller)"></button>
                        </td>
                        <td>
                            <button [disabled]="caller.UserType == 'User'" (click)="DisconnectCall(caller)" style="border: none; height: 25px;width:30px;">
                                <img alt="" src="{{ baseHref }}/assets/images/icon-call-end.svg" alt="End Call" />
                            </button>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>


    </div>
    <div class="bottom">
        <span class="menu-heading"></span>
    </div>
</div>



